import { render } from "./PartnerNoticeList.vue?vue&type=template&id=1c0fcc34"
import script from "./PartnerNoticeList.vue?vue&type=script&lang=js"
export * from "./PartnerNoticeList.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__